module.exports = require("./es-CL.d.ts");